<template>
  <div class="knowledge_personal">
    <div class="main">
      <div class="box_title">{{ name }}的客观题正确率</div>
      <div class="list">
        <template v-if="!noDo">
          <div
            class="one"
            v-for="item in questionList"
            :key="item.questionId"
            @click="currentQuestion = item"
          >
            <div class="icon">
              <i class="el-icon-success" v-show="item.right"></i>
              <i class="el-icon-error" v-show="!item.right"></i>
            </div>
            <p class="num">{{ item.num }}</p>
          </div>
        </template>
        <p class="empty-tips" v-else>本章节测试学生未完成</p>
      </div>
      <div class="question_box" v-if="currentQuestion">
        <p class="stem">
          <span>{{ currentQuestion.num }}：</span>
          <span>{{ currentQuestion.question }}</span>
        </p>
        <p class="options">
          <span v-for="item in currentQuestion.optionList" :key="item.tag">
            {{ item.tag }}、{{ item.option }}
          </span>
        </p>
        <p class="info">
          <span>正确答案：{{ currentQuestion.answerList.join(" ") }}</span>
          <span
            >学生答案：{{
              [...currentQuestion.myAnswerList].sort().join(" ") || "无"
            }}</span
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { userQuestion } from "@/api/evaluation";

export default {
  props: {
    classChapterId: Number,
    userId: Number,
    name: String,
  },
  data() {
    return {
      questionList: [],
      currentQuestion: null,
      noDo: false,
    };
  },
  created() {
    this.getQuestionInfo();
  },
  methods: {
    getQuestionInfo(classChapterId) {
      this.$loading.show();
      userQuestion({
        classId: this.$route.query.id,
        classChapterId: classChapterId || this.classChapterId,
        userId: this.userId,
      }).then((res) => {
        this.$loading.hide();
        this.noDo = res.data.length == 0;
        res.data.forEach((item, idx) => {
          item.num = `第${idx + 1}题`;
        });
        this.questionList = res.data;
        if (res.code == 0) {
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.knowledge_personal {
  .main {
    margin: 20px 2px 0;
    .box_title {
      padding: 0 10px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      color: #1de0fe;
      background-color: rgba(49, 70, 125, 0.1);
      // border: solid 1px rgba(4, 20, 40, 0.1);
      box-shadow: #6be4f7 0px 0px 5px inset;
    }
    .list {
      padding: 20px 15px;
      margin: 10px;
      text-align: left;
      box-shadow: rgba(27, 213, 246, 0.1) 0px 0px 24px inset;
      white-space: nowrap;
      overflow-x: auto;
      &::-webkit-scrollbar {
        height: 6px;
        background-color: rgb(14, 88, 113);
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
        -webkit-box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
        background-color: rgb(14, 88, 113);
      }

      &::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
        background-color: #1ae0fe;
      }

      .one {
        display: inline-block;
        margin: 0 15px;
        cursor: pointer;
        &:hover {
          .icon {
            transform: scale(1.1, 1.1);
          }
          .num {
            color: #fff;
          }
        }
        .icon {
          transition: all 0.3s ease;
          font-size: 50px;
          .el-icon-success {
            color: #6be015;
          }
          .el-icon-error {
            color: #ff3f3f;
          }
        }
        .num {
          margin-top: 30px;
          font-size: 15px;
          text-align: center;
          color: rgba(101, 198, 231, 0.5);
          transition: all 0.3s ease;
        }
      }

      .empty-tips {
        text-align: center;
        font-size: 20px;
        color: #fff;
      }
    }
    .question_box {
      position: relative;
      padding: 30px;
      text-align: left;
      color: #fff;
      .stem {
        font-weight: bold;
      }
      .options {
        margin-top: 10px;
        span {
          margin-right: 10px;
        }
      }
      .info {
        margin-top: 10px;
        span {
          margin-right: 30px;
        }
      }
    }
  }
}
</style>